
import { defineComponent, onMounted } from "vue";
import ShippingAddressReportList from "../components/ShippingAddressReportList.vue";
import { setPageHeader } from "@/core/helpers/toolbar";
export default defineComponent({
  components: {
    ShippingAddressReportList
  },
  setup() {
    onMounted(() => {
      setPageHeader({
        title: "message.SHIPPING_ADDRESS_REPORT",
        actionButton: {
          ability: "",
          pageAction: {
            action: ""
          },
          button: {}
        },
        breadCrumbs: [
          { name: "message.HOME", link: "/dashboard" },
          { name: "message.REPORTS", link: "#" },
          { name: "message.SHIPPING_ADDRESS_REPORT" }
        ]
      });
    });
  }
});
